import React from 'react';
import PropTypes from "prop-types";
import Table from "../../common/components/Table/Table";
import { Button, Checkbox, Confirm, Modal } from "semantic-ui-react";
import KYBTestCacheListRow from "./KYBTestCacheListRow";
import { connect } from "react-redux";
import AddEditKYBTestcacheForm from "./AddEditKYBTestCacheForm";
import { generateKYBCSVReport } from "../../report-generation/veritas-report-gen/ReportGeneratorActions";
import {
    addKYBTestcacheRecord,
    deleteKYBTestcacheRecord,
    editKYBTestcacheRecord,
    generateKYBPostmanReq,
    selectAllKYBTestcache,
    toggleAddKYBTestcacheRecordsModal,
    toggleDeleteKYBTestcacheRecordsModal,
    toggleEditKYBTestcacheRecordsModal
} from "../actions/KYBTestCacheActions";

export class KYBTestCacheTable extends React.Component {

    static propTypes = {
        KYBTestcacheData: PropTypes.array,
    }

    getIsKYBTestcacheRecordSelected = (recordId) => {
        return this.props.selected_kyb_testcache_records.includes(recordId);
    }

    handleKYBTestcacheCheckboxSelect = (e, { checked }) => {
        const recordIds = this.props.filtered_kyb_testcache_records.map(record => {
            return record.id  // KYB uses integer id, not guid
        });
        this.props.selectAllKYBTestcache(recordIds, checked);
    };

    handleCSVReportClick = () => {
        const { selected_kyb_testcache_records } = this.props;
        const formattedIds = selected_kyb_testcache_records.join("%2C");
        this.props.generateKYBCSVReport(formattedIds);
    };

    handleAddKYBTestcacheClick = () => {
        this.props.toggleKYBTestcacheModal();
    }

    handleEditKYBTestcacheClick = () => {
        this.props.toggleEditKYBTestcacheModal();
    }

    handleAddKYBTestcacheFormSubmit = () => {
        this.props.addKYBTestcache(this.props.kybTestcacheObject);
    }

    handleEditKYBTestcacheFormSubmit = () => {
        this.props.editKYBTestcache(this.props.kybTestcacheObject, this.props.kybTestcacheObject.id);
    }

    handleGeneratePostmanBodyClick = () => {
        this.props.generateKYBPostman();
    }

    handleCancelDeleteClick = () => {
        this.props.toggleDeleteKYBTestcacheModal();
    }

    handleDeleteKYBTestcacheClick = () => {
        this.props.deleteKYBTestcache(this.props.kybTestcacheIDForDelete);
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox
                    checked={this.props.all_kyb_testcache_records_selected}
                    onChange={this.handleKYBTestcacheCheckboxSelect}
                />
            </Table.Header>,
            <Table.Header key="edit-delete"> </Table.Header>,
            <Table.Header key="organization-name">Organization Name</Table.Header>,
            <Table.Header key="business-id">Business ID</Table.Header>,
            <Table.Header key="business-id-type">Business ID Type</Table.Header>,
            <Table.Header key="address">Address</Table.Header>,
            <Table.Header key="locality">City</Table.Header>,
            <Table.Header key="province">State/Province</Table.Header>,
            <Table.Header key="country">Country</Table.Header>,
            <Table.Header key="phone">Phone</Table.Header>,
            <Table.Header key="email">Email</Table.Header>,
            <Table.Header key="datasource">Data Source</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }

    get tableItems() {
        const { KYBTestcacheData } = this.props;
        if (!KYBTestcacheData || KYBTestcacheData.length === 0) {
            return null;
        }
        return KYBTestcacheData.map(kybTestcache => (
            <KYBTestCacheListRow
                key={kybTestcache.id}
                kybTestcacheRecord={kybTestcache}
                organizationName={kybTestcache.organization_name}
                businessId={kybTestcache.business_id}
                businessIdType={kybTestcache.business_id_type}
                addressLine1={kybTestcache.addressline1}
                locality={kybTestcache.locality}
                province={kybTestcache.province}
                postalcode={kybTestcache.postalcode}
                countryCode={kybTestcache.countrycode}
                phoneNumber={kybTestcache.phone_number}
                emailAddress={kybTestcache.full_email_address}
                domain={kybTestcache.domain}
                datasource={kybTestcache.datasource}
                id={kybTestcache.id}
                isSelected={this.getIsKYBTestcacheRecordSelected(kybTestcache.id)}
            />
        ))
    }

    render() {
        return (
            <div>
                <div style={{ padding: "20px 20px 0 30px", overflow: "hidden" }}>
                    <Button
                        icon="file excel outline"
                        size="big"
                        disabled={!this.props.all_kyb_testcache_records_selected &&
                            !this.props.some_kyb_testcache_records_selected}
                        onClick={this.handleCSVReportClick}
                        title="Export selected records to CSV"
                    />
                    <Button
                        style={{ float: "right" }}
                        color="blue"
                        icon="add"
                        content="Add a new KYB Testcache Record"
                        onClick={this.handleAddKYBTestcacheClick}
                    />
                </div>
                <div className="testcache-list-container" style={{ clear: "both" }}>
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table"
                            headers={this.tableHeaders}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.addKYBTestcacheModalOpen}
                >
                    <Modal.Header>
                        {"Add a new KYB Testcache Record"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditKYBTestcacheForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="blue"
                            inverted
                            onClick={this.handleGeneratePostmanBodyClick}>
                            Generate Postman Request
                        </Button>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleAddKYBTestcacheClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddKYBTestcacheFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.editKYBTestcacheModalOpen}
                >
                    <Modal.Header>
                        {"Edit a KYB Testcache Record"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditKYBTestcacheForm />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleEditKYBTestcacheClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleEditKYBTestcacheFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={this.props.deleteKYBTestcacheWarning}
                    content="Are you sure you want to delete this KYB Testcache Record? This action cannot be undone."
                    onCancel={this.handleCancelDeleteClick}
                    onConfirm={this.handleDeleteKYBTestcacheClick}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_kyb_testcache_records_selected: state.support.kybTestcache.all_kyb_testcache_records_selected,
    selected_kyb_testcache_records: state.support.kybTestcache.selected_kyb_testcache_records,
    filtered_kyb_testcache_records: state.support.kybTestcache.filtered_kyb_testcache_records,
    some_kyb_testcache_records_selected: state.support.kybTestcache.some_kyb_testcache_records_selected,

    kybTestcacheObject: state.support.addEditKYBTestcache.kybTestcacheObject,
    addKYBTestcacheModalOpen: state.support.addEditKYBTestcache.addKYBTestcacheModalOpen,
    editKYBTestcacheModalOpen: state.support.addEditKYBTestcache.editKYBTestcacheModalOpen,
    deleteKYBTestcacheWarning: state.support.addEditKYBTestcache.deleteKYBTestcacheWarning,
    kybTestcacheIDForDelete: state.support.addEditKYBTestcache.kybTestcacheIDForDelete,
});

const mapDispatchToProps = dispatch => ({
    selectAllKYBTestcache: (recordIds, isSelected) => { dispatch(selectAllKYBTestcache(recordIds, isSelected)) },
    generateKYBCSVReport: (selectedIds) => { dispatch(generateKYBCSVReport(selectedIds)) },
    generateKYBPostman: () => { dispatch(generateKYBPostmanReq()) },
    toggleKYBTestcacheModal: () => { dispatch(toggleAddKYBTestcacheRecordsModal()) },
    toggleEditKYBTestcacheModal: () => { dispatch(toggleEditKYBTestcacheRecordsModal()) },
    toggleDeleteKYBTestcacheModal: () => { dispatch(toggleDeleteKYBTestcacheRecordsModal()) },
    addKYBTestcache: (kybTestcacheObject) => { dispatch(addKYBTestcacheRecord(kybTestcacheObject)) },
    editKYBTestcache: (kybTestcacheObject, kybTestcacheId) => { dispatch(editKYBTestcacheRecord(kybTestcacheObject, kybTestcacheId)) },
    deleteKYBTestcache: (kybTestcacheId) => { dispatch(deleteKYBTestcacheRecord(kybTestcacheId)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBTestCacheTable)
